import {
  showStatusOverlay,
  hideStatusOverlay,
} from "../batchgeo-status-overlay";

/*
 * MarkerDrawer is the first entry point into having markers on the map.
 * it's draw() API endpoint gets called from bg.maps.js in doMap() to begin
 * putting markers on the map. This particular plugin, will build the array of markers
 * from self.options.markersData and once it's done, The list of markers will be available
 * by calling BatchGeoGoogleMapsMarker.getMarkers();
 */
(function () {
  var MarkerDrawer = function () {
    var self = this;
    var MarkerDrawerMarkers = [];
    /*
     * Markers currently available after filters applied, index in order of visible markers.
     * MarkerDrawerMarkers used to be mrks var in bg.maps.js.
     */
    var markersObjArray = [];
    var labels = [];
    var sze = BatchGeo.isRetina() ? 396 : 198;
    var labeltype = "";

    const styleDefault = {
      strokeOpacity: 0,
      strokeWeight: 0,
      fillColor: "white",
      fillOpacity: 0,
    };

    /**
     * This function will either render clusters if the cluster feature is
     * enabled or if not will render the normal markers. It will also do
     * marker clean up by clearing out clusters if they exist before
     * rendering the markers.
     *
     * @private`
     */
    var renderMarkersOrClusters = function () {
      var map = window.batchGeoGoogleMapsManager.getMap();
      if (self.MarkerDrawer._clusterStatus()) {
        window.clarker = new Clarker(map, MarkerDrawerMarkers, {
          gridSize: 70,
          maxZoom: 14,
        });
      } else {
        if (window.clarker) {
          window.clarker.clearMarkers();
        }
        let activeMarkers = [];
        if (BatchGeoStore.getState().RowSelect) {
          activeMarkers = BatchGeoStore.getState().RowSelect.selection;
        }
        MarkerDrawerMarkers.forEach(function (marker) {
          if (activeMarkers.indexOf(marker.r) != -1) {
            self.MarkerResizer.zoomIn(marker);
          }
          marker.setMap(map);
        });
      }
    };

    const validateChoropleth = async () => {
      return new Promise((resolve, _reject) => {
        const map = window.batchGeoGoogleMapsManager.getMap();
        const initCenter = map.getCenter();
        const initZoom = map.getZoom();
        map.setZoom(18);

        window.per.mapRS.forEach((r) => {
          if (r.lt && r.ln) {
            map.setCenter(new google.maps.LatLng(r.lt, r.ln));
          }
        });

        map.setCenter(initCenter);
        map.setZoom(initZoom);
        resolve();
      });
    };

    const renderChoropleth = async () => {
      if (!window.per.map_render_type.validated) {
        await validateChoropleth();
        window.per.map_render_type.validated = true;
      }

      const map = window.batchGeoGoogleMapsManager.getMap();
      window.per.map_render_type.match = [];
      const bounds = map.getBounds();
      if (!bounds) {
        google.maps.event.addListenerOnce(map, "tilesloaded", () => {
          renderChoropleth();
        });

        return;
      }

      showStatusOverlay();
      const placesToMatch = window.per.mapRS.filter(
        (r) =>
          r.boundaryAvailable &&
          bounds.contains(new google.maps.LatLng(r.lt, r.ln)),
      ).length;

      let matchCount = 0;
      const featureLayer = map.getFeatureLayer(
        window.per.map_render_type.detailLevel,
      );

      const state = BatchGeoStore.getState();
      const selectedRows = state.RowSelect.selection;
      const filteredRows = state.MarkerLegend.filteredMarkers;
      featureLayer.style = (params) => {
        const placeId = params.feature.placeId;
        const rM = window.per.mapRS.find((row) => row.placeId === placeId);
        if (rM) {
          const marker = MarkerDrawerMarkers.find(
            (marker) => marker.r === rM.r,
          );

          if (marker && marker.getMap()) {
            marker.setMap(null);
          }

          if (window.per.map_render_type.match.indexOf(placeId) === -1) {
            window.per.map_render_type.match.push(placeId);
            matchCount++;
          }

          if (matchCount >= placesToMatch) {
            hideStatusOverlay();
          }

          const color = `#${window.hex[window.per.colors.indexOf(rM.clr)]}`;
          const selected = selectedRows.includes(rM.r);
          const style = {
            ...styleDefault,
            fillColor: color,
            fillOpacity: selected ? 0.75 : 0.5,
            strokeWeight: selected ? 3 : 0,
            strokeColor: color,
            strokeOpacity: selected ? 1 : 0,
          };

          if (filteredRows.length) {
            return filteredRows.includes(rM.r) ? style : styleDefault;
          } else {
            return style;
          }
        } else {
          return styleDefault;
        }
      };

      featureLayer.addListener("click", (e) => {
        const selectedRows = [];
        e.features.forEach((feature) => {
          const rowMatch = window.per.mapRS.find(
            (row) => row.placeId === feature.placeId,
          );
          if (rowMatch) {
            selectedRows.push(rowMatch.r);
          }
        });

        if (selectedRows.length) {
          BatchGeoStore.dispatch({
            type: "ROW_SELECT_SELECT",
            selectedRows: selectedRows,
          });
        }
      });

      google.maps.event.addListenerOnce(map, "tilesloaded", () => {
        if (!BatchGeoStore.getState().App.isMap) {
          window.per.mapRS
            .filter(
              (r) => !window.per.map_render_type.match.includes(r.placeId),
            )
            .forEach((r) => {
              r.boundaryAvailable = false;
              $(".invalid-container").append(
                `<p>Row ${r.r}: ${r.addr || "(empty)"} (Boundary not found.)<br /></p>`,
              );
            });

          hideStatusOverlay();
        }
      });
    };

    /**
     * Caution: Remove labels from the DOM, which cannot be replaced without calling drawMarkers()
     * Try not to use this if possible.
     *
     * Initializing a cached map with heatmap on can result in lost label state, so we force the labels
     * off the dom to start fresh. Disabling heatmap mode redraws the labels.
     */
    var deleteLabels = function () {
      const labelEls = document.querySelectorAll(".labels");
      if (labelEls.length) {
        const labelElArr = Array.from(labelEls);
        labelElArr.forEach((element) => element.remove());
        labels = [];
      }
    };

    var getMarkersObjArray = function () {
      return markersObjArray;
    };

    /**
     * Given the filtered down markers (getMarkersObjArray) this determines
     * the label type to use for a marker. For example, if there are 27
     * markers being shown we want to use the plain marker type since we
     * can't label the 27th marker.
     *
     * @returns {string} Returns "plain" if over the marker limit for a
     * particular label otherwise it returns the labeltype as is.
     *
     * @private
     */
    var _getLabelType = function () {
      // getMarkersObjArray() will return the total count but sets
      // filtered out markers to null. Filter those out to get a filtered
      // count of markers.
      var markerLength = getMarkersObjArray().filter(function (marker) {
        return !!marker;
      }).length;

      if (
        (markerLength > 99 && labeltype === "numbers") ||
        (markerLength > 26 && labeltype === "letters")
      ) {
        return "plain";
      } else {
        return labeltype;
      }
    };

    /**
     * Optimizing icons depends on the browser and browser version. There's
     * significant performance gains by using optimized:true in icons but it
     * does not work with some browsers when using SVGs. Those browsers are
     * IE11 and lower. Edge (IE 12) and up seem to work fine.
     *
     * @return {boolean}
     * @private
     */
    var _shouldOptimizeIcon = function () {
      return !(BatchGeo.isIE() && BatchGeo.isIE() <= 11);
    };

    var getLabelStatus = function () {
      const labels = document.querySelectorAll(".labels");
      const status = { isOnDom: Boolean(labels.length), isVisible: false };
      if (labels.length) {
        status.isVisible = Array.from(labels).find(
          (l) => l.style?.visibility !== "hidden",
        );
      }
      return status;
    };

    /**
     * CheckLabels will check various states in the map to determine which, if any, labels should be rendered to the map.
     *
     * Function considers zoom distance, status of cluster mode, and markers displayed when cluster mode is enabled.
     *
     * @returns nothing
     */
    var checkLabels = function () {
      BatchGeo.timer("begin checkLabels()");
      const labelStatus = getLabelStatus();
      const { isOnDom, isVisible } = labelStatus;

      var isHeatmapEnabled = window.BatchGeoStore.getState().HeatMap.enabled;
      if (isHeatmapEnabled && (isOnDom || isVisible)) {
        deleteLabels();
        BatchGeo.timer("end checkLabels()");
        return;
      }

      // if user is zoomed way out, or heatmap is on, hide labels and exit
      var currentZoomValue = window.batchGeoGoogleMapsManager
        .getMap()
        .getZoom();
      if (!(currentZoomValue >= 14)) {
        self.MarkerDrawer.showAllLabels(false);
        BatchGeo.timer("end checkLabels()");
        return;
      }

      // if cluster mode is disabled, show all labels and exit
      var isClusterModeEnabled = self.options.markersData.clustering_cb_status;
      var isReduxClusterModeEnabled =
        window.BatchGeoStore.getState().Cluster.enabled;

      if (
        !isClusterModeEnabled &&
        !isReduxClusterModeEnabled /* && isVisible*/
      ) {
        self.MarkerDrawer.showAllLabels(true);
        BatchGeo.timer("end checkLabels()");
        return;
      }

      // in cluster mode
      // if marker is showing on the page, show label
      // if marker is NOT showing on the page, hide label.
      for (var l = 0; l < labels.length; l++) {
        var curLabel = labels[l];
        // the labels rows array contains duplicate markers, so we only need to check one.
        var isFirstDupeMarkerOnMap =
          markersObjArray[curLabel.rows[0]].marker.getMap();
        if (isFirstDupeMarkerOnMap && currentZoomValue > 14) {
          self.MarkerDrawer.showLabel(curLabel);
        } else {
          self.MarkerDrawer.hideLabel(curLabel);
        }
      }

      BatchGeo.timer("end checkLabels()");
    };

    /**
     *
     * @param {boolean} shouldTurnOnLabels - true or false
     */
    var showAllLabels = function (shouldTurnOnLabels) {
      const isLabelVisible = getLabelStatus().isVisible;
      for (var l = 0; l < labels.length; l++) {
        var curLabel = labels[l];
        if (shouldTurnOnLabels) {
          curLabel.show();
        } else if (isLabelVisible) {
          curLabel.hide();
        }
      }
    };

    var drawMarkers = function (shade) {
      if (
        !BatchGeoStore.getState().MarkerDrawer.shouldDraw ||
        !self.options.markersData.mapRS ||
        BatchGeoStore.getState().HeatMap.enabled
      ) {
        return;
      }

      if (!shade || shade == undefined) {
        shade = false;
      }

      if (window.per.disableChoropleth) {
        window.per.map_render_type = { type: "marker" };
      }

      BatchGeo.timer("start drawMarkers()");
      var r, rM;
      var map = window.batchGeoGoogleMapsManager.getMap();
      //this dispatches an action that will close the infowindow
      self.closeMarker();
      self.MarkerDrawer.clearFilteredMarkers();
      // clear the labels from dom and state before rebuilding
      deleteLabels();

      // let sum = 0;
      const showData = $("#data").length;
      window.dupes = {}; // dupe is an associative array of the coordinate pairs that helps us determine overlapping points

      for (r = 0; r < self.options.markersData.mapRS.length; r++) {
        // first pass just builds self.markers array based on filters
        rM = self.options.markersData.mapRS[r];
        if (
          BatchGeo.goodLatLon(rM.lt, rM.ln) &&
          (self.MarkerLegend.getFilters().length === 0 ||
            self.MarkerLegend.getFilteredMarkers()[r])
        ) {
          MarkerDrawerMarkers[MarkerDrawerMarkers.length] = { r: r };
          markersObjArray[r] = {};

          if (typeof rM.lt === "string") rM.lt = parseFloat(rM.lt);
          if (typeof rM.ln === "string") rM.ln = parseFloat(rM.ln);

          var loc =
            rM.lt.toFixed(4).toString() + "_" + rM.ln.toFixed(4).toString();
          if (!window.dupes[loc])
            // initalize dupe entry
            window.dupes[loc] = { drawn: false, rows: [] };

          window.dupes[loc].rows.push(r);
          markersObjArray[r].dupes = window.dupes[loc];

          // TODO(tom) sum never used
          // if (self.MarkerGroups.isThematicNumeric) {
          // 	sum += BatchGeo.val(rM.g);
          // }
          if (showData) $("#tab" + r).show();
        } else {
          markersObjArray[r] = null;
          if (showData) $("#tab" + r).hide();
        }
      }

      const keys = Object.keys(window.dupes);
      const duplicateKeys = keys.filter((key) => {
        const thisDupe = window.dupes[key];
        const dupeCount = thisDupe.rows.length;
        if (dupeCount > 1) return key;
      });
      const duplicateCount = duplicateKeys.length;

      if (
        (self.MarkerLegend.getFilters().length == 1 ||
          self.options.markersData.dist_cb_status) &&
        self.MarkerGroups.isThematicNumeric &&
        MarkerDrawerMarkers.length &&
        !self.MarkerGroups.isReverseOrder
      ) {
        MarkerDrawerMarkers.sort(function (a, b) {
          return (
            BatchGeo.val(self.options.markersData.mapRS[b.r].g) -
            BatchGeo.val(self.options.markersData.mapRS[a.r].g)
          );
        });
      }

      BatchGeo.timer("start make markers");

      self.options.markersData.shape =
        self.options.markersData.shape || "pushpin"; // default to pushpin
      var delegationMode = self.options.markersData.mapRS.length > 500; // in delegation mode events are handled at the map level vs. giving all markers clickable events

      var appState = BatchGeoStore.getState().App;

      labeltype = self.options.markersData.labeltype_sel =
        self.options.markersData.labeltype_sel || "letters";

      var drg = !appState.isMap && !delegationMode; // draggable?
      var scale =
        MarkerDrawerMarkers.length > 27 &&
        $(window).height() < 1800 &&
        labeltype != "numbers" &&
        labeltype != "letters"
          ? 0.6
          : 1; // shrink markers for larger maps

      $("#drgMsg").toggle(drg);

      var labelType = _getLabelType();
      for (var i = 0; i < MarkerDrawerMarkers.length; i++) {
        // second pass, use visible points to make markers
        r = MarkerDrawerMarkers[i].r;
        rM = self.options.markersData.mapRS[r];
        var modifier =
          self.MarkerGroups.isThematicNumeric &&
          self.MarkerLegend.getFilters().length == 1
            ? ((MarkerDrawerMarkers.length - i) / MarkerDrawerMarkers.length +
                2) *
                0.5 || 1
            : 1;
        var defaultStrokeColor = "black";
        var markerOptions = {
          position: new google.maps.LatLng(rM.lt, rM.ln),
          icon: self.MarkerDrawer._getIcon(
            i,
            rM.clr,
            defaultStrokeColor,
            1,
            scale * modifier,
            labelType,
          ),
          // label: '', // labels actually slow down performance on larger maps - even with default icons
          draggable: drg,
          // Must be false for IE! If not icons will get squished in IE
          optimized: _shouldOptimizeIcon(),
          zIndex: MarkerDrawerMarkers.length - i + 5,
          //NOTE: certain values of n used to scale eg(scale*modifier*n), can result in
          // google.maps.Point making a very misshapen image. 1.5 causes this on some maps
          // swaps the default stroke color and fill color when the marker is active
          activeIcon: self.MarkerDrawer._getIcon(
            i,
            defaultStrokeColor,
            rM.clr,
            1,
            scale * modifier,
            labelType,
          ),
          defaultIcon: self.MarkerDrawer._getIcon(
            i,
            rM.clr,
            defaultStrokeColor,
            1,
            scale * modifier,
            labelType,
          ),
          pendingIcon: self.MarkerDrawer._getIcon(
            i,
            defaultStrokeColor,
            rM.clr,
            0.6,
            scale * modifier,
            labelType,
          ),
          id: r,
        };
        // initialize marker and place on map
        var mrk = new google.maps.Marker(markerOptions);

        new BatchGeoMarkerTooltip(mrk);

        if (drg) {
          google.maps.event.addListener(mrk, "dragend", function () {
            var rM = self.options.markersData.mapRS[this.r];
            rM.lt = this.getPosition().lat();
            rM.ln = this.getPosition().lng();
            if (typeof window.cacheRow == "function") window.cacheRow(rM);
          });
        }

        if (
          BatchGeoStore.getState().App.pro &&
          !window.printMode &&
          rM.accuracy &&
          rM.accuracy == "ROOFTOP" &&
          !rM.i &&
          window.per.use_descIMG &&
          window.per.descIMG_col < 0 &&
          !self.options.markersData.hideaddr_cb
        ) {
          var svAddr = rM.addr.trim() ? rM.addr : rM.lt + "," + rM.ln;
          rM.i =
            "/api/streetview/?size=" +
            sze +
            "x" +
            sze +
            "&location=" +
            encodeURI(svAddr) +
            "&sensor=false";
        }

        mrk = delegationMode ? mrk : self.MarkerContent.createMapMarker(mrk, r); // if not clustering, go ahead and setup marker events since we will be in gmaps "optimized" mode where everything is rendered to canvas

        MarkerDrawerMarkers[i] = mrk;

        markersObjArray[r] = {
          marker: mrk,
          Lat: rM.lt,
          Lon: rM.ln,
          t: rM.t,
          u: rM.u,
          dupes: markersObjArray[r].dupes,
        };
        markersObjArray[r].marker.addr = rM.addr;
        markersObjArray[r].marker.r = r;
        markersObjArray[r].i = i;
        if (window.dupes) {
          // disable when dupes is massive, until we can figure out labels that draw only when visible
          if (
            markersObjArray[r].dupes.rows.length > 1 &&
            !markersObjArray[r].dupes.drawn
          ) {
            // draw duplicate marker label
            var last = labels.length;
            var isLastDupe = last == duplicateCount - 1;
            // current dupes
            var dup = markersObjArray[r].dupes;
            // handle "label" offset
            var dimensions = BatchGeo.getDimensions(
              dup.rows.length.toString(),
              "labels",
            );
            var markerTypeLibrary = { circle: 11, square: 0, pushpin: 0 };
            var pixelOffset = new google.maps.Size(
              -parseInt(dimensions[0] / 2),
              markerTypeLibrary[self.options.markersData.shape],
            );
            // prepare other TxtOverlay arguments
            var latLngPosition = new google.maps.LatLng(rM.lt, rM.ln);
            var textToDisplay = `${dup.rows.length}`;
            var className = "labels";
            let customEventData = null;
            if (isLastDupe) {
              customEventData = {
                title: "DUPLICATE_LABELS_DRAWN",
                callback: () => {
                  BatchGeo.timer("end draw Labels");
                  checkLabels();
                },
              };
            }
            const labelOverlay = new window.TxtOverlay(
              latLngPosition,
              textToDisplay,
              className,
              map,
              pixelOffset,
              customEventData,
            );
            labels[last] = labelOverlay;
            labels[last].rows = dup.rows;

            // flag current dupe as drawn
            dup.drawn = true;
          }
        }

        if ($("#data").length) {
          self.MarkerDrawer._addRow(r, i, labeltype); // add data below map
        }
      }

      if (labels.length) {
        google.maps.event.addListener(map, "zoom_changed", () => {
          const zoom = map.getZoom();
          if (zoom === 15) {
            showAllLabels(true);
          } else if (zoom === 14) {
            showAllLabels(false);
          }
        });
      }

      if (window.metrics)
        BatchGeo.addTimedMetric(
          "make markers",
          window.location.href,
          MarkerDrawerMarkers.length,
        );
      BatchGeo.timer("end make markers");

      if (delegationMode) {
        var overlay = new google.maps.OverlayView();
        overlay.draw = function () {};
        overlay.setMap(map);

        var $mapContainer = $(
          "#" + window.batchGeoGoogleMapsManager.settings.mapContainer,
        );
        // Remove listener if it was previously set
        $mapContainer.off("click.batchgeo.delegation");
        // event delegation for marker clicks
        $mapContainer.on("click.batchgeo.delegation", function (e) {
          var x =
            e.pageX -
            $(
              "#" + window.batchGeoGoogleMapsManager.settings.mapContainer,
            ).offset().left;
          var y =
            e.pageY -
            $(
              "#" + window.batchGeoGoogleMapsManager.settings.mapContainer,
            ).offset().top;

          // if its a div likely another map element like an infowindow we dont want to interfere, second conditional is for clicking infowindow close
          if (!e.target.src || e.target.src.indexOf("gstatic") == -1) {
            /*["A", "DIV"].indexOf(e.target.tagName.toUpperCase()) == -1 && */
            if (e && e.stop) e.stop();
            self.MarkerDrawer._openNearest(
              overlay
                .getProjection()
                .fromContainerPixelToLatLng(new google.maps.Point(x, y)),
            );
          }
        });
      }

      if (
        !window.per.disableChoropleth &&
        window.per.map_render_type.type === "choropleth"
      ) {
        renderChoropleth();
      } else {
        renderMarkersOrClusters();
      }

      BatchGeo.timer("end drawMarkers()");
      BatchGeoStore.getState().MarkerDrawer.shouldDraw = false;
    };

    var drawNonAdvancedTableMarkers = function () {
      for (var i = 0; i < MarkerDrawerMarkers.length; i++) {
        self.MarkerDrawer._addRow(MarkerDrawerMarkers[i].r, i, labeltype); // add data below map
      }
    };

    var _clusterStatus = function () {
      return BatchGeoStore.getState().Cluster.enabled;
    };

    /**
     * Creates text to be placed in a marker based on the marker's index. If you
     * give it a "letters" type it will give back a letter from A to Z based on
     * the index. For example, 0 == A, 1 == B, etc. The "numbers" labelType will
     * return a number value based on the index. In this case, 0 == 1, 1 == 2,
     * and so forth. If you give it an invalid type like "foo" it'll just return
     * an empty string.
     *
     * @param {number} iconIndex The index of this marker (i.e. 3 if it's the
     * 4th marker)
     * @param {string} labelType The type of text to generate
     * @returns {string|number} Returns a string or number value to be used as
     * the marker's text
     *
     * @private
     */
    var _getIconText = function (iconIndex, labelType) {
      var alphabet = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ];

      switch (labelType) {
        case "letters":
          return alphabet[iconIndex];
        case "numbers":
          return iconIndex + 1;
        default:
          return "";
      }
    };

    /**
     * Returns a google.maps.Marker icon options object that sets the icon to a
     * BatchGeoSvgMarkerIcon and positions it correctly depending on the type.
     *
     * @param {number} iconIndex The index of this marker (i.e. 3 if it's the
     * 4th marker)
     * @param {string} color The color name to set the marker color (i.e. "red")
     * @param {number} scale The map scale
     * @returns {object} google.maps.Marker icon options object
     *
     * @private
     */
    var _getIcon = function (
      iconIndex,
      color,
      stroke,
      opacity,
      scale,
      labelType,
    ) {
      var markersData = self.options.markersData;
      labelType = labelType || _getLabelType();
      var icon = BatchGeoSvgMarkerIcon({
        // Creates a BatchGeoSvgMarkerIcon component valid type such as
        // `circlePlain` or `circleText`
        type: markersData.shape + (labelType === "plain" ? "Plain" : "Text"),
        template: {
          width: 20 * scale,
          height:
            { pushpin: 34, circle: 20, square: 24 }[markersData.shape] * scale,
          fill: color,
          stroke: stroke,
          opacity: opacity,
          text: _getIconText(iconIndex, labelType), // passing a value here doesn't reflect on the markers?
        },
      });

      // The circle marker needs to be centered over a location rather than
      // placed on top like the others so here we change the anchor position if
      // the marker is a circle
      if (markersData.shape === "circle") {
        icon.anchor = new google.maps.Point(10 * scale, 10 * scale);
      }

      return icon;
    };

    var _addRow = function (r, v, labeltype) {
      // add data below map
      // If we're in an iframe and on iOS we do NOT render the rows
      // because it will cause the iframe to be resized to be the
      // height of all these rows + the map. See #1034
      if (BatchGeo.iframeDetect() && BatchGeoDevices.is("ios")) {
        return;
      }

      var rM = self.options.markersData.mapRS[r];
      if (!$("#tab" + r).length) {
        var options = {
          address: self.MarkerContent.createMarkerAddress(r, false),
          title: rM.t,
          description: self.MarkerContent.createMarkerDesc(r),
          descriptionURL: rM.u,
          descriptionIMG: rM.i,
          email: rM.e,
          lat: rM.lt,
          lon: rM.ln,
          coords: rM.lt + "," + rM.ln,
          isSubpremise: r.isSubpremise,
          dirAddr: r.dirAddr,
        };

        const el = $(`<div id="tab${r}" class="tabRow">
					<div id="tab${r}L" class="tabL"></div>
					${self.MarkerContent.createMarkerText(options, { useImage: false })}
					${window.per.use_descIMG ? self.MarkerContent.createMarkerImage(options) : ""}
					</div>`);

        el.on("click", (e) => {
          if (e.target.tagName.toLowerCase() !== "a") {
            window.batchGeoGoogleMapsMarker.openMarker(r);
          }
        });

        $("#data").append(el);
      }

      if (labeltype != "plain")
        $("#tab" + r + "L").html(
          self.options.markersData.labeltype_sel == "numbers"
            ? (v + 1).toString()
            : MarkerDrawerMarkers.length <= 26
              ? String.fromCharCode(65 + v)
              : "",
        );
    };

    var _openNearest = function (location) {
      var lat = location.lat(),
        lng = location.lng(),
        targetDist = 9999,
        row = -1;
      var tolerances = [
        12, 8, 6, 4, 2, 1, 0.5, 0.25, 0.1, 0.06, 0.03, 0.015, 0.0075, 0.004,
        0.002, 0.001, 0.0004, 0.0002, 0.0001, 0.00004, 0.00002,
      ]; // maximum allowable distance to marker per zoom level
      for (var i = 0; i < MarkerDrawerMarkers.length; i++) {
        if (MarkerDrawerMarkers[i].getMap() === null) continue;
        var dist = BatchGeo.distance2(
          lat,
          lng,
          MarkerDrawerMarkers[i].position.lat(),
          MarkerDrawerMarkers[i].position.lng(),
        );
        if (dist < targetDist) {
          row = MarkerDrawerMarkers[i].r;
          targetDist = dist;
        }
      }

      if (
        row >= 0 &&
        targetDist <=
          tolerances[window.batchGeoGoogleMapsManager.getMap().getZoom()]
      ) {
        // var rM = self.options.markersData.mapRS[row];
        markersObjArray[row].marker = self.MarkerContent.createMapMarker(
          markersObjArray[row].marker,
          row,
        );
        google.maps.event.trigger(markersObjArray[row].marker, "click");
        google.maps.event.clearListeners(markersObjArray[row].marker); // clear listener so it doesn't trigger with map wide listener below
      }
    };

    // call show inside a function for testing labels
    var showLabel = function (label) {
      if (label) {
        label.show();
      }
    };

    // call show inside a function for testing labels
    var hideLabel = function (label) {
      if (label) {
        label.hide();
      }
    };

    var clearFilteredMarkers = function () {
      //This should go away once we create a property to handle clearing of markers.
      if (MarkerDrawerMarkers && MarkerDrawerMarkers.length) {
        // clear old markers
        for (let r = 0; r < MarkerDrawerMarkers.length; r++)
          MarkerDrawerMarkers[r].setMap(null);

        if (window.clarker) window.clarker.clearMarkers();

        BatchGeo.timer("clear old markers, clusters, and labels");
      }
      MarkerDrawerMarkers = [];
    };
    var getMarkerCount = function () {
      return MarkerDrawerMarkers.length;
    };
    var getMarkers = function () {
      return MarkerDrawerMarkers;
    };

    var clearMarkersObjArray = function () {
      markersObjArray = [];
      return [];
    };

    var getLabels = function () {
      return labels;
    };

    var addSearchMarker = function (marker) {
      if (!marker) {
        return;
      }

      // set up marker data
      const rM = {
        lt: marker.geometry.location.lat(),
        ln: marker.geometry.location.lng(),
        addr: marker.formatted_address,
      };

      // set up marker options
      var scale =
        MarkerDrawerMarkers.length > 27 && $(window).height() < 1800
          ? 1.2
          : 1.6; // shrink markers for larger maps
      var markerOptions = {
        position: new google.maps.LatLng(rM.lt, rM.ln),
        addr: rM.addr,
        icon: {
          url:
            window.per.style === "midnight"
              ? "../../images/search-marker-light-filled.svg"
              : "../../images/search-marker-dark-filled.svg",
          scaledSize: new google.maps.Size(12 * scale, 20 * scale),
        },
        optimized: _shouldOptimizeIcon(),
      };

      // initialize marker
      var mrk = new google.maps.Marker(markerOptions);
      // get map object
      var map = window.batchGeoGoogleMapsManager.getMap();

      // clear already set marker if one exists
      if (window.per.searchMarker) {
        window.per.searchMarker.setMap(null);
        window.per.searchMarker = null;
      }
      // give the markers map reference
      mrk.setMap(map);

      // save a reference to the marker
      window.per.searchMarker = mrk;
    };

    BatchGeoStore.addListener(
      function (state) {
        return state.HeatMap;
      },
      function (newHeatmap, prevHeatmap) {
        return !_.isEqual(newHeatmap, prevHeatmap);
      },
      function (newHeatmap) {
        newHeatmap.enabled ? clearFilteredMarkers() : checkLabels();
      },
    );

    BatchGeoStore.addListener("Cluster", "enabled", function () {
      if (
        BatchGeoStore.getState().App.isMap ||
        BatchGeoStore.getState().App.mapLoaded
      ) {
        if (window.per.map_render_type.type === "marker") {
          BatchGeoStore.getState().MarkerDrawer.shouldDraw = true;
          renderMarkersOrClusters();
        }
      }
    });

    // Public API
    self.MarkerDrawer = {
      draw: drawMarkers,
      showLabel: showLabel,
      hideLabel: hideLabel,
      checkLabels: checkLabels,
      showAllLabels: showAllLabels,
      deleteLabels: deleteLabels,
      addSearchMarker: addSearchMarker,
      clearFilteredMarkers: clearFilteredMarkers,
      getMarkerCount: getMarkerCount,
      getMarkers: getMarkers,
      getLabels: getLabels,
      getMarkersObjArray: getMarkersObjArray,
      clearMarkersObjArray: clearMarkersObjArray,
      drawNonAdvancedTableMarkers: drawNonAdvancedTableMarkers,
      _getIcon: _getIcon,
      _addRow: _addRow,
      _openNearest: _openNearest,
      _clusterStatus: _clusterStatus,
      renderChoropleth: renderChoropleth,
    };
  };

  window.MarkerDrawer = MarkerDrawer;
})(window);
